
import { Quotation } from "../../classes"
const QuotaionModule = {
  namespaced: true,
  state: {
    quotation: null,
  },
  mutations: {
    setQuotation(state, quotation) {
      state.quotation = quotation || null
    },
  },
  actions: {
    createQuotation: async ({ commit, rootGetters, dispatch }, formData) => {
      try {
        const data = await Quotation.createQuotation(formData);
        return data;
      } catch (err) {
        throw err;
      }
    },
    updateQuotation: async ({ commit, rootGetters, dispatch }, formData) => {
      try {
        const data = await Quotation.updateQuotation(formData);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getQuotation: async ({ commit }, quotaionId) => {
      try {
        var result = await Quotation.getQuotation(quotaionId);
        commit('setQuotation', result)
        return result;
      } catch (error) {
        throw error
      }
    },
    sendQuotation: async ({ commit }, {id, date, dueDate}) => {
      try {
        var result = await Quotation.sendQuotation({id, date, dueDate});
        return result;
      } catch (error) {
        throw error
      }
    },
    unsendQuotation: async ({ commit }, quotaionId) => {
      try {
        var result = await Quotation.unsendQuotation(quotaionId);
        return result;
      } catch (error) {
        throw error
      }
    },
  },
};
export default QuotaionModule;
